import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type AddCertificateDTO = {
    name:string;
    description:string;
    img_url:string;
};

type CertificateResponse  = AddCertificateDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const AddNewCertificate = (data: AddCertificateDTO): Promise<CertificateResponse> => {
    return axios.post("/certificate-exam/create", data)
        .then(response => response.data as CertificateResponse);
};